// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"RZ-z","subtitle":"SZ-z","wrapper":"TZ-z","leftArrow":"UZ-z","rightArrow":"VZ-z"};